import React from "react";
import { Avatar, Heading, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";

const greeting = "Hello, I am Phomolo!";
const bio1 = "A frontend developer";
const bio2 = "specialised in React";
const img = "https://avatars.githubusercontent.com/u/105977946?v=4";

// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Avatar, Heading and VStack components.
const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="#2A4365"
  >
    <VStack marginBottom={8}>
      <Avatar src={img} size={"xl"} />
      <Heading size={"sm"}>{greeting}</Heading>
    </VStack>

    <VStack>
      <Heading>{bio1}</Heading>
      <Heading>{bio2}</Heading>
    </VStack>
  </FullScreenSection>
);

export default LandingSection;
